import { styled } from '@mui/material/styles'
import { InputBase, inputBaseClasses } from '@mui/material'

export const AppBarSearchInput = styled(InputBase)<{
  backgroundColor?: string
}>(({ theme, backgroundColor }) => ({
  margin: '0 7px',

  [`& .${inputBaseClasses.input}`]: {
    color: backgroundColor
      ? theme.palette.neutral000
      : theme.palette.neutral900,
    fontSize: theme.typography.subtitle1?.fontSize,
    fontWeight: theme.typography.subtitle1?.fontWeight,
  },
}))
